import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { appConfig } from '@ami/react/core';
import { isAmiUserAuthorizedToManageCustomerApprovals } from '@ami/react/shared';

const CustomerApprovalPanelItem = ({ entity }) => {
  const { id, name, orderName, orderPartNumber, statusName } = entity;
  return (
    <li className="row" key={id}>
      <div className="col-6">
        {appConfig.isManagementApp && isAmiUserAuthorizedToManageCustomerApprovals() && (
          <Link to={`/customer-approvals/view/${id}`}>
            <strong>{name}</strong>
          </Link>
        )}
        {appConfig.isManagementApp && !isAmiUserAuthorizedToManageCustomerApprovals() && (
          <strong>{name}</strong>
        )}
        {appConfig.isDealerApp && <div>{name}</div>}
        <div>{orderName}</div>
        <div>{orderPartNumber}</div>
      </div>
      <div className="col-6 text-end">
        <div>
          <strong>{statusName}</strong>
        </div>
      </div>
    </li>
  );
};

CustomerApprovalPanelItem.propTypes = {
  entity: PropTypes.any.isRequired,
};

export default CustomerApprovalPanelItem;
